import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  router: service(),
  // model comes from the parent funds.fund.more.tnt-connect-import.data-sync route
  // model()

  redirect(model) {
    if (get(model, 'selectedFile') == null) {
      // confirm a file has been selected
      this.router.transitionTo('funds.fund.more.tnt-connect-import.data-sync');
    }
  },
});
